import React from 'react';
import styles from './AuthPage.module.scss';

interface OrDividerProps {
  label?: string;
}

const OrDivider: React.FC<OrDividerProps> = ({ label = 'or enter details' }) => (
  <div className={styles.details}>
    <span />
    <p>{label}</p>
    <span />
  </div>
);

export default OrDivider;
